import React, { useMemo, useState, useCallback, useEffect } from 'react'
import PersonDetailsTable from 'views/Accounts/PersonDetails/PersonDetailsTable';
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { getTasks, getTaskCount } from "api/SalesApi"
import { setEditTask } from "ReduxStore/Slices/salesSlice"
import { createTaskAPI, updateTaskByIdApi } from "api/SalesApi"
import CreateTaskModal from '../CreateTaskModal'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import $ from "jquery"
export default function TaskTab({ personData, userFlow }) {

  const [currentTaskStatus, setCurrentTaskStatus] = useState('task_all')
  const [dataApi, setDataApi] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editTask, setEditTask] = useState(false);
  const [taskId, setTaskId] = useState(null)
  const taskStatus = [
    { value: 'task_all', label: '# All' },
    { value: 'task_due', label: '# Due Today' },
    { value: 'task_overdue', label: '# Overdue' },
    { value: 'task_completed', label: '# Completed' },
  ];
  const dispatch = useDispatch()

  // useEffect(() => { }, [editTask])

  // Campaign Status Component
  const RadioInput = ({ name, label, value, isChecked, handleChange }) => {
    const handleRadioChange = (e) => {
      const id = e.currentTarget.id;

      handleChange(id);
    };
    return (
      <>
        <input
          type='radio'
          className='custom-radio'
          name={name}
          id={value} // htlmlFor targets this id.
          checked={isChecked}
          onChange={handleRadioChange}
        />
        <label htmlFor={value}>
          <span>{label}</span>
        </label>
      </>
    );
  };
  const handleCampaignStatusChange = (inputValue) => {
    setCurrentTaskStatus(inputValue);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Status",
        accessor: "status",
        className: "task_status",
        maxWidth: 80,
        minWidth: 80,
        width: 80,
        Cell: ({ cell }) => {
          const status = cell.row.original.status
          if (status == 'active')
            return status == 'active' && <i title="active"
              className="far fa-check-circle"
              style={{ color: "grey", fontSize: "20px", cursor: 'pointer' }}
              onClick={(e) => {
                e.stopPropagation();

                handleUpdateTask(cell.row.original.id, { status: 'completed' })
              }}
            ></i>
          else if (status == 'completed')
            return <i title="completed"
              className="far fa-check-circle"
              style={{ color: "green", fontSize: "20px", cursor: 'pointer' }}
              onClick={(e) => {
                e.stopPropagation();

                handleUpdateTask(cell.row.original.id, { status: 'active' })

              }}
            ></i>
          else if (status == 'overdue')
            return <i title="overdue"
              className="far fa-check-circle"
              style={{ color: "rgba(150,0,0,0.8)", fontSize: "20px", cursor: 'pointer' }}
              onClick={(e) => {
                e.stopPropagation();

                handleUpdateTask(cell.row.original.id, { status: 'completed' })

              }}
            ></i>
          else return <div></div>
        }

        ,
      },
      {
        Header: "Task Name",
        accessor: "title",
      },
      {
        Header: "Assignee",
        accessor: "assignee.name",
      },
      {
        Header: "Type",
        accessor: "type",
      },
      {
        Header: "Due Date",
        accessor: "dueDateTime",
        maxWidth: 230,
        minWidth: 230,
        width: 230,
      },
      {
        maxWidth: 80,
        minWidth: 80,
        width: 80,
        Header: "",
        accessor: "name_2",
        Cell: ({ cell }) => (
          <OverlayTrigger
            delay={{ hide: 50, show: 50 }}
            placement="top"
            key="top"
            overlay={(props) => (
              <Tooltip id="tooltip-top" {...props}>
                Edit Task
              </Tooltip>
            )}
          >
            <i
              className="fa fa-edit"
              style={{ color: "gray", fontSize: "20px" }}
              onClick={(e) => {
                e.stopPropagation();

                setEditTask(true)
                setTaskId(cell.row.original.id)
              }}
              data-toggle='modal'
              data-target={
                `#createTask`
              }
            ></i>
          </OverlayTrigger>
        ),

      },

      {
        maxWidth: 80,
        minWidth: 80,
        width: 80,
        Header: "",
        accessor: "name_3",
        Cell: ({ cell }) => (
          <OverlayTrigger
            delay={{ hide: 50, show: 50 }}
            placement="top"
            key="top"
            overlay={(props) => (
              <Tooltip id="tooltip-top" {...props}>
                Delete Task
              </Tooltip>
            )}
          >
            <i
              className="fa fa-trash"
              style={{ color: "gray", fontSize: "20px" }}
              onClick={(e) => {
                e.stopPropagation();
                handleUpdateTask(cell.row.original.id, { isDeleted: true })
              }}

            ></i>
          </OverlayTrigger>
        ),
      },
    ],
    []
  );

  const getTaskStatus = (currentTaskStatus) => {
    let status = ''
    switch (currentTaskStatus) {
      case 'task_all':
        status = 'all'
        break;
      case 'task_due':
        status = 'dueToday'
        break;
      case 'task_overdue':
        status = 'overdue'
        break;
      case 'task_completed':
        status = 'completed'
        break;
      default:
        status = 'all'
        break;
    }
    return status

  }

  const queryString = ({
    pageSize,
    pageIndex,
    currentTaskStatus,
  }) => {
    let extraQuery = {};
    let taskStatus = getTaskStatus(currentTaskStatus);
    if (taskStatus == 'all') {
      extraQuery = {
        limit: pageSize,
        offset: pageSize * ((pageIndex + 1) - 1),
      }
    }
    if (taskStatus == 'dueToday') {
      extraQuery = {
        limit: pageSize,
        offset: pageSize * ((pageIndex + 1) - 1),
        status: taskStatus,
      }
    }
    if (taskStatus == 'overdue') {
      extraQuery = {
        limit: pageSize,
        offset: pageSize * ((pageIndex + 1) - 1),
        status: taskStatus,
      }
    }
    if (taskStatus == 'completed') {
      extraQuery = {
        limit: pageSize,
        offset: pageSize * ((pageIndex + 1) - 1),
        status: taskStatus,
      }
    }
    if (userFlow === 'personFlow') {
      extraQuery = { ...extraQuery, personId: personData.id }
    }
    return extraQuery

  }

  const fetchData = useCallback(async ({ pageSize, pageIndex, currentTaskStatus }) => {
    setLoading(true);
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    let qs = queryString({ pageSize, pageIndex, currentTaskStatus })

    getTasks(qs).then(data => {
      setDataApi(data);
      setLoading(false);
    })
  }, []);

  const CreateTaskButton = () => {
    return <a
      className="tpr lg_btn primary mr-2"
      data-toggle='modal'
      data-target={
        `#createTask`
      }
      style={{ cursor: 'pointer', fontSize: '18px', lineHeight: '22px' }}
      onClick={() => {
        setEditTask(false)
      }}
    >
      <span>
        <i className="fas fa-plus mr-2"></i>
      </span>
      Create Task
    </a>
  }

  const handleCreateTask = async (data) => {

    setLoading(true);
    await createTaskAPI(data).then(async (res) => {
      let qs = queryString({ pageSize: 50, pageIndex: 0, currentTaskStatus: getSelectedTaskState() })

      getTasks(qs).then(data => {
        setDataApi(data);
        setLoading(false);

      })
    })
  }

  function getSelectedTaskState() {

    let tab = ''

    try {

      if ($('#task_all').is(":checked"))
        tab = 'task_all'
      if ($('#task_due').is(":checked"))
        tab = 'task_due'
      if ($('#task_overdue').is(":checked"))
        tab = 'task_overdue'
      if ($('#task_completed').is(":checked"))
        tab = 'task_completed'

    } catch (error) {

      return ''
    }
    return tab
  }
  const handleUpdateTask = async (id, data) => {
    //  setLoading(true);

    await updateTaskByIdApi(id, data).then(async (res) => {
      let qs = queryString({ pageSize: 50, pageIndex: 0, currentTaskStatus: getSelectedTaskState() })

      getTasks(qs).then(data => {
        setDataApi(data);
        // setLoading(false);
        setEditTask(false); 

      })
    })
  }

  return (
    <div className='task_tab'>
      <CreateTaskButton />
      <div className='select-pill-button ml-2 mt-4'>
        {
          taskStatus.map((status, index) => {

            return (
              <RadioInput
                name='option'
                value={status.value}
                label={status.label}
                isChecked={currentTaskStatus === status.value}
                handleChange={handleCampaignStatusChange}
                key={index}
              />
            );
          })
        }
      </div>
      <div className='mt-4'>
        <PersonDetailsTable
          columns={columns}
          data={dataApi}
          fetchData={fetchData}
          pageCount={10}
          loading={loading}
          currentTaskStatus={currentTaskStatus}
          onRowClick={(e, row) => {
            setEditTask(true);
            setTaskId(row.original.id);
            try {
              $('#createTask').modal('show');
            } catch (e) { }
          }}
        ></PersonDetailsTable>
      </div>
      <CreateTaskModal handleCreateTask={handleCreateTask} handleUpdateTask={handleUpdateTask} personData={personData} userFlow={'fromPerson'} editTask={editTask} taskId={taskId} setEditTask={setEditTask} />
    </div>

  )
}
